import { Button, useToast, VStack } from '@chakra-ui/react';
import React from 'react';

import { TapeBuilderUI } from '@finley-technologies/tape-builder';

import { useQAContext } from './QAContext';
import { successToastConfig } from 'packages/common-frontend/constants';

type ExecuteOperationPanelProps = {
  tapeBuilderNode: TapeBuilderUI.TapeBuilderNodeAbstract;
};

export const ExecuteOperationPanel = ({
  tapeBuilderNode,
}: ExecuteOperationPanelProps) => {
  const nodeId = tapeBuilderNode.metadata.tapeBuilderNodeId;
  const {
    hasAllInputBuffers,
    generateTape,
    generateTapeDefinition,
  } = useQAContext();

  const hasInputs = hasAllInputBuffers(nodeId);

  const toast = useToast();

  const successToast = (message: string) => {
    toast({
      ...successToastConfig,
      id: `${nodeId}-success`,
      title: message,
    });
  };

  return (
    <VStack alignItems="start">
      <Button
        onClick={() => {
          const result = generateTapeDefinition(nodeId);
          if (result.isValid) {
            navigator.clipboard.writeText(
              JSON.stringify(result.tapeDefinition, null, 2),
            );
            successToast('Generated Tape Definition copied to clipboard!');
          }
        }}
      >
        Generate Definition
      </Button>

      <Button
        isDisabled={!hasInputs}
        onClick={async () => {
          const result = await generateTape(nodeId);
          if (result.isValid) {
            successToast(
              'Generated Tape Successfully. Proceed to next node to download the tape.',
            );
          }
        }}
      >
        Generate Tape
      </Button>
    </VStack>
  );
};
